<template>
  <div class="pass-panel">
    <el-form-item
      v-if="needOriginPass"
      :label="$t('api.user.oriPass')"
      :prop="prop('ori_pass')"
      :rules="oriPassRules"
      >
      <el-input
        v-model="passData[originPassField]"
        type="password"
        class="form-item"
        :placeholder="$t('api.user.error.ori_pass')"
        auto-complete="off"
        clearable>
      </el-input>
    </el-form-item>
    <el-form-item
      :prop="prop(passwordField)"
      :rules="passRules"
      ref="password"
      >
      <span
        slot="label"
        >
        {{ $t('api.user.pass') }}
        <el-popover
          placement="top"
          :title="$t('api.user.passStrength')"
          trigger="hover"
          transition="none"
          :open-delay="100"
          :tabindex="-1"
          >
          <div
            class="form-item-readme-content"
            v-html="passFeedback"
            >
          </div>
          <el-link
            slot="reference"
            class="form-item-readme-link"
            icon="el-icon-question"
            :underline="false"
            type="warning"
            >
          </el-link>
        </el-popover>
      </span>
      <el-input
        v-model="passData[passwordField]"
        type="password"
        class="form-item"
        :placeholder="$t('api.user.error.auth_pass')"
        auto-complete="off"
        clearable
        >
        <el-button
          slot="append"
          icon="el-icon-refresh"
          @click="genPass"
          :tabindex="-1"
          >
        </el-button>
      </el-input>
      <password
        v-model="passData[passwordField]"
        :strength-meter-only="true"
        @score="setScore"
        @feedback="showFeedback"
        >
      </password>
    </el-form-item>
    <el-form-item
      :label="$t('api.user.confirmPass')"
      :prop="prop(passwordConfirmField)"
      :rules="passConfirmRules"
      ref="passwordConfirm"
      >
      <el-input
        v-model="passData[passwordConfirmField]"
        type="password"
        class="form-item"
        :placeholder="$t('api.user.error.auth_pass')"
        auto-complete="off"
        clearable>
      </el-input>
    </el-form-item>
  </div>
</template>

<script>

import Password from 'vue-password-strength-meter'
import { doCopy } from '@/utils/copy'

const generator = require('generate-password')

export default {
  components: {
    Password
  },
  name: 'password-input',
  props: {
    base: {
      type: String,
      default: ''
    },
    formRef: {
      type: Object,
      default: () => {}
    },
    passData: {
      type: Object,
      required: true
    },
    originPassField: {
      type: String,
      default: 'ori_pass'
    },
    passwordField: {
      type: String,
      default: 'auth_token'
    },
    passwordConfirmField: {
      type: String,
      default: 'auth_token_c'
    },
    needOriginPass: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      passFeedback: this.$t('api.user.passStrengthDesc'),
      passScore: 0,
      prop: (name) => {
        return this.base === '' ? name : (this.base + '.' + name)
      },
      oriPassRules: [
        {
          required: true,
          message: this.$t('api.user.error.ori_pass'),
          trigger: 'blur'
        }
      ],
      passRules: [
        {
          required: true,
          validator: this.validPass,
          trigger: 'blur'
        }
      ],
      passConfirmRules: [
        {
          required: true,
          validator: this.validPassConfirm,
          trigger: 'blur'
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    doCopy,
    genPass () {
      var pass = generator.generate({
        length: 16,
        numbers: true,
        symbols: true,
        excludeSimilarCharacters: true,
        exclude: '"\'><[]()\\/',
        strict: true
      })
      this.doCopy(pass)
      this.passData[this.passwordField] = pass
      this.passData[this.passwordConfirmField] = pass
      this.$nextTick(() => {
        this.$refs.password.clearValidate()
        this.$refs.passwordConfirm.clearValidate()
      })
    },
    showFeedback ({suggestions, warning}) {
      var msg = '<div class="el-alert el-alert--info is-light">' + this.$t('api.user.passStrengthDesc') + '</div>'
      if (suggestions && suggestions.length) {
        msg += '<div class="el-alert el-alert--warning is-light">🙏 : ' + suggestions.join('<br>') + '</div>'
      }
      if (warning) {
        msg += '<div class="el-alert el-alert--error is-light"> ⚠️  : ' + warning + '</div>'
      }
      this.passFeedback = msg
    },
    setScore (score) {
      this.passScore = score
    },
    validPass (rule, value, callback) {
      if (value === '' || value.length < 6) {
        callback(new Error(this.$t('api.user.error.auth_pass')))
      } else if (this.passScore < 4) {
        callback(new Error(this.$t('api.user.error.auth_pass_strength')))
      } else {
        if (this.passData[this.passwordConfirmField] !== '') {
          var e = this.formRef || this.$parent
          if (typeof e.validateField === 'function') {
            e.validateField(this.prop(this.passwordConfirmField))
          }
        }
        callback()
      }
    },
    validPassConfirm (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('api.user.error.auth_pass_c')))
      } else if (value !== this.passData[this.passwordField]) {
        callback(new Error(this.$t('api.user.error.auth_pass_match')))
      } else {
        callback()
      }
    }
  },
  watch: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .pass-panel {
    .el-form-item:last-child {
      margin-bottom: 22px;
    }
  }
</style>
